module.exports = __webpack_public_path__ + "media/images/partners/taiwan-police-aadd0b10899662d25cdcfe02f26993c5.png";